/**
 * Configuration for AHEPA frontend.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'AHEPA Hellenic Career Center',
    SITE_DESCRIPTION:
      'The AHEPA HELLENIC CAREER CENTER is a comprehensive AI-powered job board serving the Greek American and Greek Canadian communities. It provides job seekers and employers with award-winning technology used by major brands worldwide.',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/ahepa/logo.png',
      faviconsPath: '/static/ahepa',
    },
    OG_IMAGE: '/static/ahepa/og-image.jpeg',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#1b3f95',
        secondary: '#ef3e36',
      },
    },
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ', 'G-3JJ5D1NBHS'],
  },
});
